/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 13.07.2016
 *
 */


'use strict';
import L from 'external/leaflet';
import { DataUtil, shallowEqual } from 'plugin/liferay-widgets-react-web';
import FeatureManager from '../utils/FeatureManager';
import { getBoundsFromGeometries } from '../utils/geo-utils';

export default class FeatureDisplayPlugin {

    constructor(props) {
        this.boundRequestHandled = false;
        this.boundRequestCb = this.boundRequestCb.bind(this);
    }

    init(map, o) {
        this.update(map, o);
    }

    initOptions(o) {
        return this.options(o);
    }

    options(o) {
        if ((o.features && !shallowEqual(o.features, this.features)) || (o.features && !this.boundRequestHandled)) {
            this.boundRequestHandled = false;
            const features = Array.isArray(o.features) ? o.features : [ o.features ];
            const geometries = features.filter(f => DataUtil.asItem(f)).map(f => DataUtil.asItem(f).geometry);

            if (geometries && geometries.length > 0) {
                o.boundRequest = {
                    bounds: getBoundsFromGeometries(geometries),
                    options: { animate: false },
                    cb: this.boundRequestCb
                };
            }
        }

        return o;
    }

    update(map, o) {
        if (o.features && !shallowEqual(o.features, this.features)) {
            this.features = Array.isArray(o.features) ? o.features : [ o.features ];

            const featureLayers = this.features.filter(f => DataUtil.asItem(f)).map(data => {
                if (data.properties || !data.className) {
                    throw new Error("Data expected", data);
                }
                let feature = this.asFeature(data);
                let layer = FeatureManager.createFeatureLayer(feature, {}, true);
                if (layer.then) {
                    const loadingLayer = FeatureManager.loadingMarker(feature);
                    layer.then(() => {
                        if (map.hasLayer(loadingLayer)) {
                            map.removeLayer(loadingLayer);
                            map.addLayer(FeatureManager.createFeatureLayer(feature, {}));
                        }
                    });
                    layer = loadingLayer;
                }
                return layer;
            });

            if (!this.featureGroup && featureLayers) {
                this.featureGroup = L.featureGroup(featureLayers).addTo(map);
            } else {
                this.featureGroup.clearLayers();
                featureLayers.forEach(layer => this.featureGroup.addLayer(layer));
            }

        }
    }

    asFeature(dataItem) {
        const type = dataItem.className;
        const item = DataUtil.asItem(dataItem);
        if (item === dataItem){
            console.error("Expected a dataItem not an item, because only dataItem knows which type it is.", dataItem);
        }

        if (item && item.geometry && type) {
            return {
                geometry: item.geometry,
                properties: {
                    ...item,
                    type
                },
                type: 'Feature'
            };
        }
        throw new Error("Item incompatible!")
    }

    boundRequestCb() {
        this.boundRequestHandled = true;
    }
}



// WEBPACK FOOTER //
// ./js/plugins/FeatureDisplayPlugin.js